import config from './production.js'

const conf = {
    ...config,
    title: 'Amdocs Storefront Experience',
    carePortal: {
        urls: {
            adminAuthUrl: 'https://attus02.ulm.stg.m1amdocs.io',
        },
        agentClientId: 'HaloCTestRP',
        ssoClientId: 'haloeFederationClientID',
        ssoClientSecret: '',
        OAuthParam: {
            scope: 'openid profile',
            extras: {},
        },
    },
    urls: {
        ...config.urls,
        apiUrl: 'https://amazing.ulm.demo.m1amdocs.io/platform/rest/v85',
        authUrl: 'https://amazing.ulm.demo.m1amdocs.io',
        userPreferencesUrl: 'https://amazing.ulm.demo.m1amdocs.io/customData',
        storefrontUrl: 'https://amazing.ulm.demo.m1amdocs.io/storefront',
        emi: {
            baseUrl: 'https://waf-attus-emi-wa-sbk001.ifs.vubiquity.com/curation-api',
            homePath: '3.0/{population}/1',
            defaultPopulation: 'stg-2',
        },
        proxyUrl: 'https://waf-attus-metadata-api-sbk001.ifs.vubiquity.com/maculosa/v3.1',
        ifsApiUrl: 'https://ifs.demo.m1amdocs.io',
        iframePaymentUrl: '',
    },
    clientId: '45ba33b0e7634874ab7f3d7c5d3c45cd',
    origins: {
        preconnect: true, // boolean: false if you want to disable preconnect
        // array of strings: list of endpoints to preconnect to
        endpoints: [
            'https://m1amdocs.io',
            'https://attus.ulm.stg.m1amdocs.io',
            'https://waf-attus-emi-wa-sbk001.ifs.vubiquity.com',
            'https://plm-prodtest.m1amdocs.io',
            'https://waf-attus-metadata-api-sbk001.ifs.vubiquity.com',
        ],
    },
    encryption: {
        enabled: false,
    },
    env: 'staging',
    OAuthParam: {
        ...config.OAuthParam,
        extras: {
            ...config.OAuthParam.extras,
        },
    },
    paymentMethodView: {
        viewType: 'basic', // 'basic', 'modal' | default is 'basic'
        hosted: false, // false for internal integration, true when hosting an iframe
    },
}

export default conf
